import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CrudService, CrudType, IApplicationResponse, ModulesBasedApiSuffix, RxjsService, addDefaultTableObjectProperties, onActionSubmittedUtil, prepareGetRequestHttpParams } from '@app/shared';
import { UserModuleApiSuffixModels } from '@modules/user/shared';
import { PrimeNgTableVariablesModel } from '../../../../../shared/models/prime-ng-table-list-component-variables.model';
@Component({
  selector: 'app-feature-list',
  templateUrl: './feature-list.component.html',
})

export class FeatureListComponent extends PrimeNgTableVariablesModel {
  primengTableConfigProperties: any = {
    tableCaption: "Feature List",
    breadCrumbItems: [{ displayName: 'Internal Settings', relativeRouterUrl: '' },
    { displayName: 'Feature List', relativeRouterUrl: '' }],
    tableComponentConfigs: {
      tabsList: [
        {
          caption: 'Feature List',
          dataKey: 'registrationId',
          columns: [{ field: 'moduleName', header: 'Module Name ', width: '200px' },
          { field: 'navigationName', header: 'Navigations', width: '200px' },
          { field: 'featureName', header: 'Features', width: '200px' },
          ],
          apiSuffixModel: UserModuleApiSuffixModels.FEATURE_LIST,
          moduleName: ModulesBasedApiSuffix.IT_MANAGEMENT
        }
      ]
    }
  }

  constructor(private rxjsService: RxjsService, private crudService: CrudService, private router: Router) {
    super();
    this.primengTableConfigProperties = addDefaultTableObjectProperties(this.primengTableConfigProperties);
  }

  ngOnInit(): void {
    this.rxjsService.setGlobalLoaderProperty(false);
    this.getRequiredListData();
  }

  1
  getRequiredListData(pageIndex?: string, pageSize?: string,
    otherParams?: object) {
    this.loading = true;
    this.crudService.get(
      ModulesBasedApiSuffix.IT_MANAGEMENT,
      UserModuleApiSuffixModels.FEATURE_LIST,
      undefined,
      false, prepareGetRequestHttpParams(pageIndex, pageSize, otherParams), 1
    ).subscribe((response: IApplicationResponse) => {
      if (response.isSuccess && response.statusCode === 200 && response.resources) {
        this.dataList = response.resources;
        this.totalRecords = response.totalCount;
        this.rxjsService.setGlobalLoaderProperty(false);
      }
      this.loading = false;
    });
  }

  onCRUDRequested(type: CrudType | string, row?: object, searchObj?: any): void {
    switch (type) {
      case CrudType.CREATE:
        this.openAddEditPage(CrudType.CREATE, row);
        break;
      case CrudType.GET:
        this.getRequiredListData(row["pageIndex"], row["pageSize"], searchObj);
        break;
      case CrudType.EDIT:
        this.openAddEditPage(CrudType.EDIT, row);
        break;
      case CrudType.VIEW:
        this.openAddEditPage(CrudType.EDIT, row);
        break;
    }
  }

  openAddEditPage(type: CrudType | string, editableObject?: object | string): void {
    switch (type) {
      case CrudType.CREATE:
        this.router.navigate(['user/features/add-edit']);
        break;
      case CrudType.EDIT:
        this.router.navigate(['user/features/add-edit'], { queryParams: { navigationId: editableObject['navigationId'], moduleId: editableObject['moduleId'] } });
        break;
    }
  }

  onActionSubmited(e) {
    onActionSubmittedUtil(e, this.onCRUDRequested.bind(this));
  }

  onChangeSelecedRows(e) {
    this.selectedRows = e;
  }
}
